<template>
    <!-- 生产单详情 -->
    <div>
        <product-order-header-info ref="orderHeaderInfo"/>
        <product-order-craft-info ref="craftInfo"/>
        <product-order-machine-info ref="workOrderInfo"/>
    </div>
</template>

<script>
import { productOrderHeaderInfo, productOrderCraftInfo, productOrderMachineInfo } from './components'
export default {
    components: { productOrderHeaderInfo, productOrderCraftInfo, productOrderMachineInfo },
    data() {
        return {
            productOrderInfo: {}
        }
    },
    methods: {
        // 根据ID，获取生产单信息
        getProductOrderInfo(productOrderId) {
            this.$requestBase({
                url: 'v1/factory/product-order/find/id',
                method: 'get',
                params: { productOrderId }
            }).then(res => {
                res = res.data
                this.productOrderInfo = res
                this.$refs.orderHeaderInfo.setProductOrderHeader(res)
                this.$refs.craftInfo.setCraftOrder(res.craftsheet)
                this.$refs.workOrderInfo.setWorkOrders(res.workOrders)
            })
        }
    },
    created () {
        this.getProductOrderInfo(this.$route.params.id)
    }
}
</script>

<style lang='scss' scoped>
</style>
